import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CheckIndicator from '../__partials/check-indicator';
import idGenerator from '../../__utils/idGenerator';

const Checkbox = ({ label, value, id, checked, disabled, onChange, qaId, nested, partiallyChecked }) => {
  const newId = id || idGenerator();
  const isChecked = checked && !(disabled && nested);

  const className = classNames('uni-form__check-item', {
    'uni-form__check-item--child': nested,
    'uni-form__check-item--is-checked': isChecked,
    'uni-form__check-item--is-indeterminate': !checked && partiallyChecked,
    'uni-form__check-item--is-disabled': disabled,
  });

  return (
    <div className={className}>
      <label className="uni-form__label--check" htmlFor={newId}>
        <CheckIndicator />

        <input
          id={newId}
          className="uni-form__input--check"
          type="checkbox"
          value={value}
          checked={isChecked}
          disabled={disabled}
          onChange={() => onChange(value)}
          data-qa-id={qaId}
        />

        {label}
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  id: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  partiallyChecked: PropTypes.bool,
  nested: PropTypes.bool,
  qaId: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  onChange: () => {},
  partiallyChecked: false,
  nested: false,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/forms/checkbox/index.jsx